export const GET_COUNTRIES = gql`
    query GetCountries {
        countries {
            alpha2Code
            name
            postalCodeType
            currencies {
                code
                name
                symbol
            }
            flags {
                svg
            }
            callingCodes {
                code
            }
        }
    }
`;
export const GET_DEFAULT_CURRENCY = gql`
    query getDefaultCurrency {
        getDefaultCurrency {
            symbol
        }
    }
`;
export const GET_CURRENCY_BY_CODE = gql`
    query getCurrencyByCode($code: String!) {
        getCurrencyByCode(code: $code) {
            symbol
        }
    }
`;
